import './index.css'
import React from 'react'
import ReactDOM from 'react-dom'

import SetupApp from './Setup/setUp'

ReactDOM.render(
  <React.StrictMode>
    <SetupApp />
  </React.StrictMode>,
  document.getElementById('root'),
)
